import {Component, Optional} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef} from '@angular/material/snack-bar';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'pm-pwa-update-snackbar',
    imports: [MatSnackBarLabel, TranslateModule, MatSnackBarActions, MatButton, MatSnackBarAction],
    templateUrl: './pwa-update-snackbar.component.html',
    styleUrl: './pwa-update-snackbar.component.css'
})
export class PwaUpdateSnackbarComponent {
  constructor(@Optional() protected matSnackBarRef: MatSnackBarRef<PwaUpdateSnackbarComponent>) {

  }
}
